import * as React from "react";
import { useFormContext, type FieldError } from "react-hook-form";
import { FormFieldContext } from "./types";
import { FormItemContext } from "./constants";

export const useFormField = (): {
  id: string;
  name: string;
  formItemId: string;
  formDescriptionId: string;
  formMessageId: string;
  isDirty: boolean;
  isTouched: boolean;
  invalid: boolean;
  error?: FieldError;
} => {
  const fieldContext = React.useContext(FormFieldContext);

  if (!fieldContext || !fieldContext.name) {
    throw new Error("useFormField should be used within <FormField>");
  }

  const itemContext = React.useContext(FormItemContext);
  const { getFieldState, formState } = useFormContext();

  const fieldState = getFieldState(fieldContext.name, formState);

  const { id } = itemContext;

  return {
    id,
    name: fieldContext.name,
    formItemId: `${id}-form-item`,
    formDescriptionId: `${id}-form-item-description`,
    formMessageId: `${id}-form-item-message`,
    ...fieldState,
  };
};
